import styled from 'styled-components';
import {
  desktop_breakpoint,
  desktop_breakpoint_extended,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const CategoryPageStyles = styled.div`
  .posts {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .load-more {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 64px;
    .compact {
      font-size: 14px;
      height: 51px;
      align-content: center;
    }
  }

  @media screen and (min-width: ${desktop_breakpoint}px) {
    .constrained-width {
      margin-top: 100px;
    }
    .posts {
      grid-gap: 45px 20px;
    }
  }

  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    .posts {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
`;

export default CategoryPageStyles;
